import { Backdrop, Box, CircularProgress, CssBaseline, ListItem, Popover, Tab, Tabs, Typography } from '@mui/material';
import { heading } from '../../newReports/data';
import HeaderListPage from './headerList';
import { useParams } from 'react-router-dom';
import { useReportContext } from '../ReportContext';
import { useEffect } from 'react';

const Header = () => {
  const { reportData, loading } = useReportContext();
  console.log(loading, 'kkkkkkkkkkkkkkkkk');

  // Use the data from BankCashBook or other report components
  useEffect(() => {
    if (reportData) {
      console.log('Data received in Header:', reportData);
      // You can use reportData here to update header state, display counts, etc.
    }
  }, [reportData]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
      {heading.map((dat) => {
        return <HeaderListPage key={dat.id} dat={dat} />;
      })}
    </Box>
  );
};
export default Header;
